import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AppConfigService, CommonCoreModule, FullPageMaskService, LoggingInterceptor, SecurityService, TokenInterceptor } from 'common';
import { BannerDataService, CardDataService, HeaderNavSubitemComponent, RootLayoutModule } from 'root-layout';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from '../app.component';
import { MaterialModule } from './material.module';
import { SecurityServiceFactory } from '../utilities/factories/security-service-factory';
import { DOCUMENT } from '@angular/common';
import { AccountsModule } from 'accounts';
import { RouteHistoryService } from '../services/route-history.service';

const appInitialiserFn = (appConfig: AppConfigService, bannerData: BannerDataService, cardData: CardDataService, security: SecurityService) => () =>
  appConfig
    .loadAppConfig()
    .then(() => appConfig.loadAppIcons())
    .then(() => bannerData.loadBannerData())
    .then(() => cardData.loadCardData())
    .then(() => security.initialise(appConfig.config));

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AccountsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CommonCoreModule,
    RootLayoutModule,
    MaterialModule,
    RootLayoutModule,
    HeaderNavSubitemComponent,
  ],
  providers: [
    AppConfigService,
    {
      provide: SecurityService,
      useFactory: SecurityServiceFactory,
      deps: [DOCUMENT, HttpClient]
    },
    FullPageMaskService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitialiserFn,
      multi: true,
      deps: [AppConfigService, BannerDataService, CardDataService, SecurityService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }



